/* eslint-disable react-hooks/exhaustive-deps */
import { Link } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { MyButton } from "../../component/Component";
import { useStaticContext } from "../../../../context/static/StaticContext";
import { pushOneEmail } from "../../../../middlewares/sysNavigation/SysNavigation";

const editRoute = "/email/edit";

const Overview = () => {
  const [emailList, setEmailList] = useState([]);
  const { emailTemplates, getEmailTemplates } = useStaticContext();

  useEffect(() => {
    if (!emailTemplates) getEmailTemplates();
    else setEmailList(emailTemplates);
  }, [emailTemplates]);

  return (
    <div className="h-full overflow-hidden rounded-b-xl bg-gradient-to-b from-gray-50 to-white">
      <div className="mx-auto flex h-full w-full max-w-7xl flex-col px-3 py-4 lg:px-6">
        {/* Header */}
        <div className="mb-4 rounded-xl border border-gray-200 bg-white p-4 shadow-sm">
          <div className="flex flex-col gap-1 sm:flex-row sm:items-center sm:justify-between">
            <div>
              <h1 className="text-sm font-semibold tracking-tight text-gray-900 lg:text-base">
                Email Templates
              </h1>
              <p className="text-[11px] text-gray-500">
                Manage reusable messages sent from your platform.
              </p>
            </div>
            <span className="inline-flex items-center gap-2 rounded-full bg-gray-50 px-3 py-1 text-[11px] font-medium ring-1 ring-gray-200">
              <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" />
              Items: {Array.isArray(emailList) ? emailList.length : 0}
            </span>
          </div>
        </div>

        {/* Table */}
        <div className="rounded-xl border border-gray-200 bg-white shadow-sm">
          <div className="w-full overflow-x-auto">
            <table className="min-w-full table-auto text-left text-sm">
              <thead>
                <tr className="bg-gray-50">
                  <th className="w-1/3 border-b border-gray-200 px-4 py-3 font-semibold text-gray-700">
                    Title
                  </th>
                  <th className="w-1/3 border-b border-gray-200 px-4 py-3 font-semibold text-gray-700">
                    Message
                  </th>
                  <th className="w-1/3 border-b border-gray-200 px-4 py-3 text-center font-semibold text-gray-700">
                    Action
                  </th>
                </tr>
              </thead>

              <tbody className="divide-y divide-gray-100">
                {emailList ? (
                  emailList?.map((template) => (
                    <tr
                      key={template?.email_templates_id}
                      className="transition-colors hover:bg-gray-50"
                    >
                      <td className="px-4 py-3 align-top">
                        <div className="font-medium text-gray-900 break-words">
                          {template?.title}
                        </div>
                      </td>
                      <td className="px-4 py-3 align-top">
                        <div className="max-w-[60ch] whitespace-pre-line break-words text-gray-700">
                          {template?.message}
                        </div>
                      </td>
                      <td className="px-4 py-3">
                        <ActionButton template={template} />
                      </td>
                    </tr>
                  ))
                ) : (
                  // loading skeleton
                  Array.from({ length: 3 }).map((_, i) => (
                    <tr key={i} className="animate-pulse">
                      <td className="px-4 py-3">
                        <div className="h-4 w-40 rounded bg-gray-200" />
                      </td>
                      <td className="px-4 py-3">
                        <div className="h-4 w-64 rounded bg-gray-200" />
                      </td>
                      <td className="px-4 py-3">
                        <div className="mx-auto h-9 w-20 rounded-lg bg-gray-200" />
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Helper text */}
        <p className="mt-3 text-[11px] text-gray-500">
          Keep subject lines clear and messages concise for higher engagement.
        </p>
      </div>
    </div>
  );
};

/**
 *  @author Ntavigwa Bashombe
 * @param {*} template
 * @returns
 */
const ActionButton = ({ template }) => {
  return (
    <div className="flex items-center justify-center">
      <Link to={editRoute}>
        <MyButton
          title="Edit"
          className="rounded-lg bg-blue-600 px-3 py-2 text-xs font-semibold shadow-sm transition hover:bg-blue-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500"
          onClick={() => pushOneEmail(template)}
        />
      </Link>
    </div>
  );
};

export default Overview;
